import { render, staticRenderFns } from "./ServiceNumbersView.vue?vue&type=template&id=50abe7fe&"
import script from "./ServiceNumbersView.vue?vue&type=script&lang=js&"
export * from "./ServiceNumbersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports